import React from 'react';
import PropTypes from 'prop-types';
import ProgressBar from '../shared/ProgressBar';

const ParticipantDetail = ({ capacity, joined, canceled, fillRate, cancelRate }) => (
  <div className="o-dashboard__section">
    <h3 className="o-dashboard__section-title">参加者詳細</h3>
    <div className="o-pr-point">
      <div style={{ display: 'flex', gap: '24px', marginBottom: '12px', flexWrap: 'wrap' }}>
        <div className="o-pr-point__stat">定員: <strong>{capacity}</strong>名</div>
        <div className="o-pr-point__stat">参加: <strong>{joined}</strong>名</div>
        <div className="o-pr-point__stat">キャンセル: <strong>{canceled}</strong>名</div>
      </div>
      <ProgressBar
        value={joined}
        max={capacity}
        label={`充足率: ${fillRate}% | キャンセル率: ${cancelRate}%`}
      />
    </div>
  </div>
);

ParticipantDetail.propTypes = {
  capacity: PropTypes.number.isRequired,
  joined: PropTypes.number.isRequired,
  canceled: PropTypes.number.isRequired,
  fillRate: PropTypes.number.isRequired,
  cancelRate: PropTypes.number.isRequired,
};

export default ParticipantDetail;
